import axios from "axios";

const useMockAPIForDebug = (
  api,
  mockedSuccessResponse,
  mockedFailureResponse
) => {
  // Mock API hook is active only in development
  if (process.env.NODE_ENV !== "development") return;

  const shouldIntercept = response => response.config.url?.indexOf(api) > -1;

  /**
   * override the success response, with provided mocked success response
   * @param {object} successResponse original axios success response object
   * @returns if intercepted returns modified success response, else the original response
   */
  function axiosSuccessInterceptor(successResponse) {
    if (shouldIntercept(successResponse)) {
      return {
        ...successResponse,
        data: mockedSuccessResponse
      };
    } else {
      return successResponse;
    }
  }

  /**
   * override the failure response, with provided mocked faillure response
   * @param {object} errorResponse original axios failure response object
   * @returns Rejected promise. If intercepted returns modified error response, else the original error response
   */
  function axiosFailureInterceptor(errorResponse) {
    if (shouldIntercept(errorResponse)) {
      const updatedResponse = {
        ...errorResponse.response,
        data: mockedFailureResponse
      };

      return Promise.reject({
        ...errorResponse,
        response: updatedResponse
      });
    } else {
      return Promise.reject(errorResponse);
    }
  }

  axios.interceptors.response.use(
    axiosSuccessInterceptor,
    axiosFailureInterceptor
  );
};

export default useMockAPIForDebug;
